import React from "react";

const TicketNumberNormalization = ({ row }) => {
  return <div>{row?.ticketNumber?.toLocaleString()}</div>;
};

export default TicketNumberNormalization;
